import {ShapeType, type TLevelConfig} from "./types.js";

export const config = {
  version: "1.0.0",
  globalConstraints: {
    maxPosition: [10000, 10000],
    minPosition: [-10000, -10000],
    minScale: [1, 1],
    maxScale: [100, 100],
  },
  objectTypes: {
    spawn: {
      displayName: "Spawn",
      description: "Player starting point. Only one allowed.",
      image: "spawn_zfvryp",
      shape: ShapeType.CIRCLE,
      shapeIndex: 0,
      limit: 1,
      zLevel: 1,
      defaultScale: [4, 4],
    },
    shard: {
      displayName: "Shard",
      description: "Collect to complete the level.",
      image: "shard_etlvff",
      shape: ShapeType.CIRCLE,
      shapeIndex: 1,
      limit: 1000,
      zLevel: 2,
      scaleFactor: 0.001,
      defaultScale: [4, 4],
    },
    attractor: {
      displayName: "Attractor",
      description: "Pulls the player toward it.",
      image: "attractor_ird7wi",
      shape: ShapeType.ATTRACTOR,
      shapeIndex: 0,
      limit: 1000,
      zLevel: 0,
      defaultScale: [10, 10],
    },
    plastic: {
      displayName: "Plastic",
      description: "Bouncy surface with low friction.",
      image: "plastic_learer",
      shape: ShapeType.RECTANGLE,
      shapeIndex: 0,
      limit: 1000,
      zLevel: 3,
      defaultScale: [2, 2],
    },
    sand: {
      displayName: "Sand",
      description: "High friction, slows movement.",
      image: "sand_ysrzta",
      shape: ShapeType.RECTANGLE,
      shapeIndex: 1,
      limit: 1000,
      zLevel: 3,
      defaultScale: [2, 2],
    },
    ice: {
      displayName: "Ice",
      description: "Slippery surface with low friction.",
      image: "ice_icpgrt",
      shape: ShapeType.RECTANGLE,
      shapeIndex: 2,
      limit: 1000,
      zLevel: 3,
      defaultScale: [2, 2],
    },
    fire: {
      displayName: "Fire",
      description: "Deadly on contact.",
      image: "fire_hjoqco",
      shape: ShapeType.RECTANGLE,
      shapeIndex: 3,
      limit: 1000,
      zLevel: 3,
      defaultScale: [2, 2],
    },
  },
} satisfies TLevelConfig;
